import './Field.scss';
import Component from './Field.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
